import { Injectable } from '@angular/core';
import { HttpService, MessageService } from 'brainloper-ui';
import { rejects } from 'assert';
import { BaseResponse } from 'app/models2/commos/base-response';
import { GenericResponse } from 'app/models2/commos/generic-response';

@Injectable({
  providedIn: 'root'
})
export class DeleteGenericService {

  constructor(
    private http: HttpService,
    private message: MessageService,
  ) {
  }

  public deleteD($event: Array<any>, url: string, primaryKey: string, labels?: string, labelp?: string, withoutWarning: boolean = false): Promise<boolean> {
    return new Promise(async (resolve, rejects) => {
      if (withoutWarning) {
        for (const element of $event) {
          await this.deleteWhitoutWarning(url, element[primaryKey])
        }
      } else {
        let cuanti: string = ''
        if (!labels) {
          labels = "registro"
        }
        if (!labelp) {
          labelp = "registros"
        }
        if ($event.length == 1) {
          cuanti = `Desea eliminar ${labels}`
        } else {
          cuanti = `Desea eliminar ${labelp}`
        }
        this.message.Warning(cuanti, ``, true).then(
          async (res: boolean) => {
            if (res == true) {
              let sucessDelete = true

              try {
                this.message.openLoading('Cargando', `Eliminando ${labels}`)
                for (const element of $event) {
                  if(!await this.deleteWhitoutWarning(url, element[primaryKey])){
                    sucessDelete = false
                  }
                }

                if(sucessDelete){
                  if ($event.length == 1) {
                    this.message.SuccessToast(`${labels} eliminados correctamente`)

                  } else {
                    this.message.SuccessToast(`${labelp} eliminados correctamente`)

                  }
                }

                resolve(res);
                this.message.closeLoading()
              } catch (error) {
                rejects(false)
                this.message.closeLoading()
              }

            } else {
              resolve(res);
              this.message.closeLoading()
            }
          }
        )
      }
      return true
    })


  }

  public async deleteWhitoutWarning(url: string, element) {
    let res: BaseResponse<GenericResponse> = await this.http.deleteDataPromise(`${url}/${element}`)
    if (res['code'] === 0) {
      return true
    } else {
      this.message.Warning('Error!', res.message)
      return false
    }
  }

  public async inactivateOrActivate(entities: Array<any>, active: boolean, activeUrl: string, inactiveUrl: string, itemName: string): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      let url = active ? activeUrl : inactiveUrl;
      let cuanti = entities.length === 1 ? `Desea ${active ? 'activar' : 'inactivar'} ${itemName}` : `Desea ${active ? 'activar' : 'inactivar'} ${itemName}s`;

      this.message.Warning(cuanti, '', true).then(
        async (res: boolean) => {
          if (res) {
            try {
              this.message.openLoading('Cargando', `${active ? 'Activando' : 'Desactivando'} ${itemName}`);

              for (const entity of entities) {
                await this.http.putDataBody<GenericResponse>(url, { [entity.id ? "id" : "userId"]: entity.id || entity.userId });
                if (entities.length == 1) {
                  this.message.SuccessToast(`${itemName} ${active ? 'activado' : 'desactivado'} correctamente`)
  
                } else {
                  this.message.SuccessToast(`${itemName} ${active ? 'activados' : 'desactivados'} correctamente`)
  
                }
              }     

              resolve(res);
              this.message.closeLoading();
            } catch (error) {
              reject(error);
            }
          } else {
            resolve(res);
          }
        }
      );
    });
  }

}
